import React from "react";
import { Modal, Space } from "antd";
import { RiDashboardLine } from "react-icons/ri";
import { LiveDashboardCore } from "./core/LiveDashboardCore";

const LiveDashboardModal = ({ open, onClose, machineID }) => {
  if (!open) return null;

  return (
    <Modal
      title={
        <Space>
          <RiDashboardLine />
          <span>室內定位即時監控</span>
        </Space>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width="95%"
      style={{ top: 20, maxWidth: 1600 }}
      bodyStyle={{
        padding: 16,
        maxHeight: "calc(100vh - 120px)",
        overflow: "hidden",
      }}
    >
      <div style={{ height: "calc(100vh - 160px)" }}>
        <LiveDashboardCore machineID={machineID} className="modal-variant" />
      </div>
    </Modal>
  );
};

export default LiveDashboardModal;
